<template>
  <ListeReferentiel
    ref="liste"
    titre="Chambres"
    icone="bi-building"
    ressource="chambres"
    tri-defaut="ch.numero"
    :options-tri="{ Numéro: 'ch.numero', Type: 'tch.nom', Statut: 'ch.isEnabled', 'Date de création': 'ch.createdAt' }"
    placeholder="Numéro ou type de chambre…"
    unite="chambre(s)"
    vide="Aucune chambre enregistrée."
    :colonnes="9"
    :filtres="{ type }"
    :peut-creer="$store.getters.hasPermission('CONFIG_CREER_CHAMBRE')"
    libelle-creer="Nouvelle chambre"
    @creer="creation"
  >
    <template #filtres>
      <div class="col-6 col-md-2">
        <label class="form-label fw-semibold small mb-1">Type</label>
        <select v-model="type" class="form-select form-select-clinique">
          <option value="">Tous</option>
          <option v-for="t in types" :key="t.id" :value="t.id">{{ t.nom }}</option>
        </select>
      </div>
    </template>
    <template #entete>
      <th>Numéro</th>
      <th>Type</th>
      <th class="d-none d-md-table-cell">Lits</th>
      <th>Lits libres</th>
      <th>Lits occupés</th>
      <th class="d-none d-md-table-cell">Tarif / jour</th>
      <th>État</th>
      <th>Actions</th>
    </template>
    <template #ligne="{ ligne: chambre }">
      <td>{{ chambre.numero }}</td>
      <td>{{ chambre.type?.nom || '—' }}</td>
      <td class="d-none d-md-table-cell">{{ chambre.nombreLit ?? (chambre.lits || []).length }}</td>
      <td><span class="badge bg-success">{{ litsLibres(chambre) }}</span></td>
      <td><span class="badge bg-danger">{{ (chambre.lits || []).length - litsLibres(chambre) }}</span></td>
      <td class="d-none d-md-table-cell">{{ Number(chambre.type?.tarifParJour || 0).toLocaleString('fr-FR') }} F</td>
      <td><span :class="['badge', classeEtat(chambre)]">{{ etatChambre(chambre) }}</span></td>
      <td>
        <div v-if="$store.getters.hasAnyPermission(['CONFIG_MODIFIER_CHAMBRE', 'CONFIG_SUPPRESSION_CHAMBRE'])" class="dropdown">
          <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" v-dropdown-fixed>Actions</button>
          <ul class="dropdown-menu">
            <li v-if="$store.getters.hasPermission('CONFIG_MODIFIER_CHAMBRE')"><a class="dropdown-item" href="#" @click.prevent="modifier(chambre.id)">Modifier</a></li>
            <li v-if="$store.getters.hasPermission('CONFIG_SUPPRESSION_CHAMBRE')"><a class="dropdown-item text-danger" href="#" @click.prevent="supprimer(chambre)">Supprimer</a></li>
          </ul>
        </div>
      </td>
    </template>
  </ListeReferentiel>
</template>

<script>
import api from '@/api';
import ListeReferentiel from '@/components/commun/ListeReferentiel.vue';

export default {
  name: 'ListeChambre',
  components: { ListeReferentiel },
  data() {
    return { type: '', types: [] };
  },
  async created() {
    try {
      const res = await api.getItems('type_chambres', { orderBy: 'tch.nom', sortOrder: 'asc' });
      this.types = res.data?.data || [];
    } catch {
      this.types = [];
    }
  },
  methods: {
    litsLibres(chambre) {
      return (chambre.lits || []).filter(l => String(l.etat || '').toLowerCase() === 'libre').length;
    },
    etatChambre(chambre) {
      const total = (chambre.lits || []).length;
      const libres = this.litsLibres(chambre);
      if (libres === total) return 'Disponible';
      if (libres === 0) return 'Occupée';
      return 'Partiellement occupée';
    },
    classeEtat(chambre) {
      const etat = this.etatChambre(chambre);
      if (etat === 'Disponible') return 'bg-success';
      if (etat === 'Occupée') return 'bg-danger';
      return 'bg-warning text-dark';
    },
    creation() {
      this.$router.push({ name: 'create_chambre' });
    },
    modifier(id) {
      this.$router.push({ name: 'edit_chambre', params: { id } });
    },
    supprimer(chambre) {
      this.$refs.liste.supprimer({
        id: chambre.id,
        titre: 'Supprimer la chambre',
        message: `Supprimer la chambre ${chambre.numero} ?`,
        succes: 'Chambre supprimée.',
      });
    },
  },
};
</script>
